function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export class BaseSearchQueryField {
  constructor(searchOptions) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    _defineProperty(this, "internalValue", void 0);
    _defineProperty(this, "_isAvailable", void 0);
    _defineProperty(this, "default", void 0);
    this.default = defaultValue;
    if (this.isAvailableForType(searchOptions.listingType)) {
      this.internalValue = value !== null && value !== void 0 ? value : defaultValue;
      this._isAvailable = true;
    } else {
      this.internalValue = null;
      this._isAvailable = false;
    }
  }
  getInput() {
    return undefined;
  }
  get value() {
    return this.internalValue;
  }
  getCondensedValue() {
    var _this$value;
    return (_this$value = this.value) !== null && _this$value !== void 0 ? _this$value : null;
  }
  getSingleValue() {
    return this.value;
  }
  isDefault() {
    return this.internalValue === this.default;
  }
  isAvailable() {
    return this._isAvailable;
  }
  get validListingTypes() {
    return null;
  }
  isAvailableForType(listingType) {
    return this.validListingTypes ? this.validListingTypes.includes(listingType) : true;
  }
}